package com.narbase.letsgo.web.utils.views

import com.narbase.kunafa.core.components.View
import kotlinx.dom.addClass

/**
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2020/04/09.
 */

fun View.addClass(className: String) = element.addClass(className)